import { Directive, HostListener } from "@angular/core";
import { NgControl } from "@angular/forms";

@Directive({
	selector: "[appNumber]",
	standalone: false
})
export class NumberDirective {
	constructor(private ngControl: NgControl) {}

	@HostListener("input", ["$event.target.value"])
	onInput(eventValue: string): void {
		this.format(eventValue);
	}

	@HostListener("paste", ["$event"])
	onPaste(event: ClipboardEvent): void {
		event.preventDefault();
		if (event.clipboardData) {
			this.format(event.clipboardData.getData("text/plain"));
		}
	}

	format(inputValue: string): void {
		if (inputValue.trim().length === 0) {
			this.ngControl.control?.setValue(0);
			return;
		}
		const replaceNotNumbers = inputValue.replace(/[^0-9]*/g, "");
		this.ngControl.control?.setValue(Number(replaceNotNumbers));
	}
}
